// import axios from "axios";

const baseURL = "https://king-prawn-app-bhitz.ondigitalocean.app/";
// const baseURL = "http://localhost:3039/";

// const HTTP = {
//   get: axios.get,
//   post: axios.post,
//   put: axios.put,
//   delete: axios.delete,
// };

const sendPostFileReq = async (requestUrl, data) => {
  debugger
  const url = baseURL + requestUrl;
  const getApiData = async () => {
    debugger
    const requestsOptions = {
      method: "POST",
      body: (data),
      // headers: {
      //   'content-type': 'multipart/form-data',
      // },
    };

    return await fetch(url, requestsOptions)
      .then((response) => response.json())
      .then((data) => {
        console.log("Response Data: " + JSON.stringify(data));
        return data;
      })
      .catch((err) => {
        console.log("Emaina Error:", err);
        throw err;
      });
  };
  return getApiData();
};

const sendPostReq = async (requestUrl, data) => {
  const url = baseURL + requestUrl;
  console.log(requestUrl);

  // console.log("Request Data: ", data);

  const getApiData = async () => {
    debugger
    const requestsOptions = {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      },
    };
    console.log("Executing Post");
    return await fetch(url, requestsOptions)
      .then((response) => response.json())
      .then((data) => {
        console.log("Response Data: " + JSON.stringify(data));
        return data;
      })
      .catch((err) => {
        console.log("Emaina Error:", err);
        throw err;
      });
  };
  return getApiData();
};

const sendGetReq = async (requestUrl) => {
  // data = JSON.stringify(data);

  const url = baseURL + requestUrl;
  console.log(requestUrl);

  const getApiData = async () => {
    const requestsOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    console.log("Executing Fetch");
    return await fetch(url, requestsOptions)
      .then((response) => response.json())
      .then((data) => {
        debugger
        console.log("Data: " + data);
        return data;
      })
      .catch((err) => {
        console.log("Emaina Error:", err);
        throw err;
      });
  };
  return getApiData();
};




const sendPutReq = async (requestUrl, data) => {
  const url = baseURL + requestUrl;
  console.log(requestUrl);

  console.log("Request: ", data);

  const getApiData = async () => {
    const requestsOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data),
    };
    console.log("Executing Fetch");
    return await fetch(url, requestsOptions)
      .then((response) => response.json())
      .then((data) => {
        console.log("Data: " + JSON.stringify(data));
        return data;
      })
      .catch((err) => {
        console.log("Emaina Error:", err);
        throw err;
      });
  };
  return getApiData();
};



export { sendPostReq, sendGetReq, sendPostFileReq,sendPutReq };


